import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  // Header of the list view: a count on the left, the add action on the right.
  listHeader: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '8px'
  },
  listCount: {
    color: palette.shades[700],
    fontFamily: palette.fontFamilies.source,
    fontSize: '13px'
  },
  listRow: {
    alignItems: 'center',
    borderBottom: "1px solid ".concat(palette.shades[300]),
    display: 'flex',
    fontFamily: palette.fontFamilies.source,
    gap: '16px',
    justifyContent: 'space-between',
    padding: '14px 0'
  },
  listRowMain: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    minWidth: 0
  },
  listRowName: {
    color: palette.shades[800],
    fontFamily: palette.fontFamilies.poppins,
    fontSize: '15px',
    fontWeight: 600,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  listRowMeta: {
    alignItems: 'center',
    color: palette.shades[600],
    display: 'flex',
    flexWrap: 'wrap',
    fontSize: '13px',
    gap: '8px'
  },
  listRowActions: {
    alignItems: 'center',
    display: 'flex',
    flexShrink: 0,
    gap: '6px',
    // The theme puts 10px between adjacent actionIcons, which stacks on top of the gap.
    // These belong to one row, so the gap alone spaces them.
    '& .MuiButton-actionIcon + .MuiButton-actionIcon': {
      marginLeft: 0
    }
  },
  // A text action, not a filled one: the row already carries two icon buttons.
  setDefaultButton: {
    backgroundColor: 'transparent',
    color: palette.primary.main,
    fontSize: '13px',
    minHeight: 'auto',
    padding: '4px 6px',
    '&:hover': {
      backgroundColor: palette.shades[200]
    }
  },
  badge: {
    backgroundColor: palette.shades[250],
    borderRadius: '2px',
    color: palette.shades[700],
    fontSize: '12px',
    lineHeight: '18px',
    padding: '1px 8px'
  },
  badgeDefault: {
    backgroundColor: palette.success.light,
    color: palette.success.dark
  },
  emptyState: {
    color: palette.shades[600],
    fontFamily: palette.fontFamilies.source,
    fontSize: '14px',
    padding: '40px 0',
    textAlign: 'center'
  },
  // Editor
  sectionLabel: {
    color: palette.shades[600],
    fontFamily: palette.fontFamilies.poppins,
    fontSize: '11px',
    fontWeight: 600,
    letterSpacing: '0.04em',
    marginBottom: '8px',
    textTransform: 'uppercase'
  },
  editorTopRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px'
  },
  scopeRow: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
    marginTop: '8px'
  },
  scopeHint: {
    color: palette.shades[600],
    fontFamily: palette.fontFamilies.source,
    fontSize: '13px'
  },
  // Two panes: everything selectable on the left, the file being built on the right.
  columnsLayout: {
    display: 'grid',
    gap: '20px',
    gridTemplateColumns: 'minmax(240px, 1fr) minmax(360px, 1.6fr)'
  },
  pane: {
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: '2px',
    // Both panes share one height so the row never ends on a ragged edge.
    height: '330px',
    overflowY: 'auto',
    padding: '8px 12px'
  },
  paneEmpty: {
    alignItems: 'center',
    color: palette.shades[600],
    display: 'flex',
    fontFamily: palette.fontFamilies.source,
    fontSize: '13px',
    height: '100%',
    justifyContent: 'center',
    textAlign: 'center'
  },
  fieldGroupTitle: {
    color: palette.shades[600],
    fontFamily: palette.fontFamilies.poppins,
    fontSize: '11px',
    fontWeight: 600,
    letterSpacing: '0.04em',
    margin: '10px 0 2px',
    textTransform: 'uppercase'
  },
  fieldOption: {
    alignItems: 'center',
    display: 'flex',
    gap: '6px',
    '& .MuiFormControlLabel-root': {
      marginRight: 0
    }
  },
  fieldOptionNote: {
    color: palette.shades[600],
    fontSize: '11px',
    whiteSpace: 'nowrap'
  },
  paneLabelCount: {
    color: palette.shades[600],
    fontWeight: 400,
    letterSpacing: 0,
    textTransform: 'none'
  },
  columnCard: {
    borderBottom: "1px solid ".concat(palette.shades[250]),
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    padding: '12px 0',
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  columnCardTop: {
    alignItems: 'center',
    display: 'flex',
    gap: '8px'
  },
  // The pane promises "in file order", so each row says which column it will be.
  columnPosition: {
    backgroundColor: palette.shades[250],
    borderRadius: '2px',
    color: palette.shades[700],
    flexShrink: 0,
    fontFamily: palette.fontFamilies.poppins,
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '24px',
    textAlign: 'center',
    width: '24px'
  },
  columnCardActions: {
    display: 'flex',
    flexShrink: 0,
    gap: '4px',
    '& .MuiButton-actionIcon + .MuiButton-actionIcon': {
      marginLeft: 0
    }
  },
  // Everything the header input cannot say: which Livable field feeds it, and what it will write.
  columnCardMeta: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    paddingLeft: '32px'
  },
  columnCardField: {
    color: palette.shades[600],
    fontFamily: palette.fontFamilies.source,
    fontSize: '12px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  staticChip: {
    backgroundColor: palette.shades[250],
    borderRadius: '2px',
    color: palette.shades[800],
    fontFamily: 'monospace',
    fontSize: '11px',
    maxWidth: '180px',
    overflow: 'hidden',
    padding: '1px 6px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  columnWarning: {
    color: palette.warning.dark,
    fontFamily: palette.fontFamilies.source,
    fontSize: '12px'
  },
  advancedToggle: {
    backgroundColor: 'transparent',
    color: palette.primary.main,
    fontSize: '12px',
    marginLeft: 'auto',
    minHeight: 'auto',
    padding: '2px 6px',
    '&:hover': {
      backgroundColor: palette.shades[200]
    }
  },
  // A wrapper, not padding on the TextField itself: MUI positions the outlined label absolutely
  // against the field root, so padding there pushes the box and leaves the label behind it.
  staticValueField: {
    borderLeft: "2px solid ".concat(palette.shades[300]),
    marginLeft: '11px',
    paddingLeft: '19px'
  },
  // The header row as the PMS will see it, which is what is really being configured.
  preview: {
    backgroundColor: palette.shades[200],
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: '2px',
    color: palette.shades[800],
    fontFamily: 'monospace',
    fontSize: '12px',
    overflowX: 'auto',
    padding: '12px 14px',
    whiteSpace: 'nowrap'
  },
  previewEmpty: {
    color: palette.shades[600]
  },
  warning: {
    color: palette.warning.dark,
    display: 'block',
    fontFamily: palette.fontFamilies.source,
    fontSize: '13px',
    marginTop: '8px'
  }
}));
export default useStyles;